import { useMemo } from 'react';
import type { CellContext } from '@tanstack/react-table';
// import { PlusCircle } from 'react-feather';
import { cx } from '@trinity/chat-components';
import { TagBadge } from '@/components/Transcript';
import type { ProjectClips } from '@/types/project.clips';
// import { SetTaggedMomentEditParamsContext } from '@/containers/Transcript/context.tagged-moment';
// import { ProjectClipsFiltersContext } from '@/containers/Project.Clips';
// import { useDeleteTranscriptMomentMutation, useInvalidateProjectClipsQuery } from '@/utils/api';
// import { VisibleOnHoverOverlay } from '@/components/Editable';
// import { TagBadgeMenu } from './Tag.Menu';
import styles from './style/Cell.Tags.module.css';

type Props = CellContext<ProjectClips.Item, unknown>;

export const Cell = (props: Props) => {
  const tagsWithCounts = useMemo(() => {
    const map: {
      [id: number]: {
        count: number;
        tag: ProjectClips.Tag;
      };
    } = {};
    props.row.original.tags.forEach(tag => {
      const count = (map[tag.id]?.count || 0) + 1;
      map[tag.id] = {
        count,
        tag: {
          ...tag,
          name: count > 1 ? `${tag.name} (${count})` : tag.name,
        },
      };
    });
    const tags = Object.values(map).map(m => m.tag);

    return tags.sort((a, b) => a.name.localeCompare(b.name));
  }, [props.row.original.tags]);

  return (
    <div className={styles.root}>
      {tagsWithCounts.map(tag => (
        <TagBadge key={tag.id} tag={tag} />
      ))}
    </div>
  );
};

Cell.displayName = 'Column.Tags.Cell';